import { MedplumClient } from "@medplum/core";
import { Bundle, QuestionnaireResponse } from "@medplum/fhirtypes";

import { ProceduresFormTypeWithId } from "@/zod-schemas/procedures";

export const softDeleteProcedureQuestionnaireResponse = async (
  medplum: MedplumClient,
  questionnaireResponseId: string,
) => {
  medplum.invalidateSearches("QuestionnaireResponse");
  const questionnaireResponse = await medplum.readResource(
    "QuestionnaireResponse",
    questionnaireResponseId,
  );

  if (!questionnaireResponse) return;

  return await medplum.updateResource({ ...questionnaireResponse, status: "stopped" });
};

export const fetchQuestionnaireResponseHistory = async (
  medplum: MedplumClient,
  procedureList: ProceduresFormTypeWithId[],
) => {
  const historyPromises = procedureList
    .filter((procedure) => procedure.exists)
    .map(
      (procedure) =>
        medplum.readHistory("QuestionnaireResponse", procedure.id) as Promise<
          Bundle<QuestionnaireResponse>
        >,
    );

  const historyResults = await Promise.all(historyPromises);

  const historyHashMap = historyResults.reduce(
    (hashMap, bundle) => {
      const questionnaireResponseId = bundle.entry?.[0]?.resource?.id;

      if (questionnaireResponseId) {
        hashMap[questionnaireResponseId] =
          bundle.entry?.map((entry) => entry.resource! as QuestionnaireResponse) ?? [];
      }

      return hashMap;
    },
    {} as Record<string, QuestionnaireResponse[]>,
  );

  return historyHashMap;
};
